import { useSentryContext } from '@/hooks/use-sentry-context';

/**
 * Component that provides Sentry context updates
 * Must be placed inside QueryClientProvider since it uses React Query hooks
 */
export function SentryContextProvider({ children }: { children: React.ReactNode }) {
  // Initialize Sentry context for user and business data
  useSentryContext();
  
  return <>{children}</>;
}
